module.exports = "<div *ngIf=\"customer$ | async as customer \">{{customer.client}}</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/customer-name/customer-name.component.html
// module id = ./src/app/shared/customer-name/customer-name.component.html
// module chunks = main